import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

/**
 * Retires a page: every visitor goes to /home during route recognition, so no
 * other guard, request or lazy chunk for the page ever runs. Deliberately reads
 * no flag. To re-enable a page, delete its `canMatch` line in the routes.
 */
export const retiredPageGuard = (() =>
  inject(Router).createUrlTree(['/home'])) satisfies CanMatchFn;
